import { ref } from 'vue';
import { useCustomToast } from '../use/useCustomToast';
import { shouldShowErrorToast } from '../utils/errors';
import type { SearchParams } from '../types/search.types';

export interface SearchServiceConfig<T> {
  searchUrl: string;
  context?: 'search' | 'gestao';
  searchFunction: (
    endpoint: string,
    searchParams: SearchParams
  ) => Promise<{ data: T[]; metadata: any }>;
}

export default function useSearchService<T>(config: SearchServiceConfig<T>) {
  const items = ref<T[]>([]);
  const metadata = ref<any>();
  const toast = useCustomToast();

  const searchItems = async (searchParams: SearchParams) => {
    try {
      const response = await config.searchFunction(searchParams.searchUrl, searchParams);

      items.value = response.data;
      metadata.value = response.metadata;
    } catch (error) {
      if (shouldShowErrorToast(error)) {
        toast.showErrorToast({
          title: 'Erro ao buscar itens',
          message: 'Tente novamente mais tarde.',
          type: 'error',
        });
      } else {
        items.value = [];
        metadata.value = {
          total: 0,
          page: 1,
          totalPages: 0,
          isNextPage: false,
          isPreviousPage: false,
        };
      }
      console.error('Erro ao buscar itens:', error);
    }
  };

  return {
    searchItems,
    items,
    metadata,
  };
}
